import React from 'react';

const PatientReports = () => {
  const reports = [
    {
      name: 'Blood Test',
      date: '2025-06-01',
      issuedBy: 'Dr. John Smith',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'X-Ray Chest',
      date: '2025-05-22',
      issuedBy: 'Radiology Lab',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'Urine Analysis',
      date: '2025-05-15',
      issuedBy: 'PathCare Lab',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'MRI Brain',
      date: '2025-04-28',
      issuedBy: 'City Scan Center',
      status: 'Pending',
      link: '#',
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h3>Patient Reports</h3>

      <table className="full-width-table">
        <thead>
          <tr>
            <th>Report</th>
            <th>Date</th>
            <th>Issued By</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report, index) => (
            <tr key={index}>
              <td>{report.name}</td>
              <td>{report.date}</td>
              <td>{report.issuedBy}</td>
              <td>{report.status}</td>
              <td>
                {report.status === 'Completed' ? (
                  <a href={report.link} target="_blank" rel="noopener noreferrer">
                    View
                  </a>
                ) : (
                  'Not available'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PatientReports;
